// This file contains a fix for the ResizeObserver loop limit exceeded error
// It works by adding a global error handler that ignores this specific error

export const applyResizeObserverFix = () => {
  // Create a global error handler
  const errorHandler = (event) => {
    // Check if the error is the ResizeObserver loop limit exceeded error
    if (
      event.message === 'ResizeObserver loop limit exceeded' ||
      event.message === 'ResizeObserver loop completed with undelivered notifications.'
    ) {
      // Prevent the error from appearing in the console
      event.stopImmediatePropagation();
    }
  };

  // Add the error handler to the window
  window.addEventListener('error', errorHandler, true);
  
  // Return a cleanup function to remove the error handler
  return () => {
    window.removeEventListener('error', errorHandler, true);
  };
};

export default applyResizeObserverFix;
